import { Base } from '../../abstract/base.model';
import { nullableDecimal, nullableString } from '../utils/wire-value-utils';
import { isRecord } from '../utils/is-record';
import { PaymentRevisionActorType } from './payment-revision-actor-type.model';
import { PaymentRevisionType } from './payment-revision-type.model';

/**
 * One row of a payment's revision timeline: GET /admin/payments/:id/revisions, built to the agreed
 * `ADMIN_PAYMENT_REVISION_READABLE` list. Read-only; unsent fields stay `undefined`, `null` stays `null`.
 */
export class MarketplacePaymentRevision extends Base {
  revisionType?: PaymentRevisionType | null;
  billableAcres?: number | null;
  pricePerAcre?: number | null;
  grossAmount?: number | null;
  farmerSurchargeAmount?: number | null;
  totalChargeAmount?: number | null;
  actorProfileId?: string | null;
  actorType?: PaymentRevisionActorType | null;
  notes?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.revisionType = nullableString(source['revisionType']) as PaymentRevisionType | null | undefined;
    this.billableAcres = nullableDecimal(source['billableAcres']);
    this.pricePerAcre = nullableDecimal(source['pricePerAcre']);
    this.grossAmount = nullableDecimal(source['grossAmount']);
    this.farmerSurchargeAmount = nullableDecimal(source['farmerSurchargeAmount']);
    this.totalChargeAmount = nullableDecimal(source['totalChargeAmount']);
    this.actorProfileId = nullableString(source['actorProfileId']);
    this.actorType = nullableString(source['actorType']) as PaymentRevisionActorType | null | undefined;
    this.notes = nullableString(source['notes']);
  }
}
